<template lang="html">

	<section class="home">

		<section class="intro-home column-start">
			<span class="background"></span>
			<div class="container row-start">
				<div class="contenedor-info-intro">
					<h1>#Inergízate</h1>
				</div>
			</div>

			<div class="imagenes-intro-home row-end" @mouseenter="playvideo">

				<div class="imagen -imagen-1 column-end"></div>
				<div class="imagen -imagen-2"></div>
				<div class="imagen -imagen-3" @click="playvideo" v-if="!hidevideo">
					<video playsinline muted id="video-home" poster="/static/video/poster-video-autoconsumo.jpg" @click="playvideo">
						<source :src="'/static/video/video-autoconsumo.mp4'" type="video/mp4">    
						</video>
					</div>

					<router-link class="btn -skull-orange -gray-c -flecha-naranja" :to="$t('enlaces.autoconsumo')">
						Simula tu instalación solar
					</router-link>

				</div>

			</section>


			<section class="contenedor-video-home-mvl" v-if="!hidevideo">
				<video muted playsinline autoplay controls id="video-home" poster="/static/video/poster-video-autoconsumo.jpg" @click="playvideo">
					<source :src="'/static/video/video-autoconsumo.mp4'" type="video/mp4">    
					</video>
			</section>

			<section class="banner-home-autoconsumo">
				<router-link class="btn -skull-orange -gray-c -flecha-naranja" :to="$t('enlaces.autoconsumo')">
					Calcula el precio de tu instalación solar
				</router-link>
			</section>


			<slider-promos></slider-promos>

			<banner-somos-ahorro></banner-somos-ahorro>	

			<banner-somos-ventajas></banner-somos-ventajas>	

			<noticias-home></noticias-home>

			<banner-dicen-de-nosotros></banner-dicen-de-nosotros>	

		</section>

	</template>

	<script lang="js">

		import sliderPromos from '@/components/parts/slider-promos';
		const bannerSomosAhorro = () => import('@/components/parts/banner-somos-ahorro');
		const bannerSomosVentajas = () => import('@/components/parts/banner-somos-ventajas');
		const bannerDicenDeNosotros = () => import('@/components/parts/banner-dicen-de-nosotros');
		const noticiashome = () => import('@/components/parts/noticias-home');


		export default  {
			name: 'home',
			mounted(){
				window.addEventListener('resize', () => {
					this.hidevideo = (window.innerWidth <= 600);
				});
			},
			data:() => ({
				hidevideo : false
			}),
			components : {
				'banner-somos-ahorro' : bannerSomosAhorro,
				'banner-somos-ventajas' : bannerSomosVentajas,
				'banner-dicen-de-nosotros' : bannerDicenDeNosotros,
				'slider-promos' : sliderPromos,
				'noticias-home' : noticiashome,
			},
			methods:{
				playvideo(){
					document.getElementById("video-home").play();
				},
				stopvideo(){
					document.getElementById("video-home").pause();
				}
			},

		}
	</script>

	<style scoped>
		.container{

			position: relative;
			z-index: 6;
			width: 100%;
		}

		.contenedor-info-intro{
			position: relative;
			left: 0;
			bottom: 0;
			display: inline-block;
			padding-bottom: 140px;
		}

		.imagen.-imagen-3{
			position: relative;
		}

		.imagen video{
			width: 100%;
			display: inline-block;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			transition: .5s;
		}

		@media screen and (max-width: 600px){
			.container{
				padding: 0;
			}

			.contenedor-info-intro{
				padding-bottom: 0;
				display: -webkit-flex;
				display: -moz-flex;
				display: -ms-flex;
				display: -o-flex;
				display: flex;
			}
		}

	</style>



// WEBPACK FOOTER //
// src/components/views/home.vue